<template>
	<div class="author-selector" id="author-selector">
		<div class="pa-block">
			<div class="pa-block__inner">
				<label for="author">Utilisateur</label>
				<autocomplete
					ref="autocomplete"
					:placeholder="
						classified.author_name ? classified.author_name : 'Utilisateur...'
					"
					:search="search"
					:get-result-value="getResultValue"
					@submit="handleSubmit"
				></autocomplete>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import axios from "axios";

export default {
	name: "author-selector",
	components: {
		Autocomplete,
	},
	computed: {
		...mapState(["classified", "isAdmin", "isDev"]),
	},
	methods: {
		search(input) {
			return new Promise((resolve) => {
				if (input.length < 2) {
					return resolve([]);
				}

				axios
					.post(
						this.config.app.gateway + "?action=classified_v2_get_authors",
						{
							action: "classified_v2_get_authors",
							search: input,
						},
						{
							headers: {
								"Content-Type": "application/json",
							},
						}
					)
					.then((response) => response.data)
					.then((data) => {
						resolve(data);
					})
					.catch((response) => {
						//
					});
			});
		},
		getResultValue(result) {
			return result.display_name;
		},

		handleSubmit(result) {
			this.$store.commit("setAuthor", result.ID);
			this.$store.commit("setAuthorName", result.display_name);
		},
	},
};
</script>
